module.exports = __webpack_public_path__ + "img/reward-6.fc648b0b.svg";